import React, { useEffect, useRef, useState } from 'react';
import { AutocompleteInput, Autocomplete, AutocompleteList, AutocompleteListItem, AutocompleteListItems, } from '@stepstone-genesis/components';
const AutocompleteComponent = ({ items = [], clearInput, onChange, onToggle, }) => {
    const [inputValue, setInputValue] = useState('');
    const containerRef = useRef(null);
    const input = containerRef.current?.querySelector('input');
    const observer = new MutationObserver((mutationsList) => {
        for (const { type, attributeName } of mutationsList) {
            if (type === 'attributes' && attributeName === 'aria-expanded') {
                if (onToggle)
                    onToggle({ isOpen: input?.ariaExpanded === 'true' });
            }
        }
    });
    useEffect(() => {
        if (input) {
            observer.observe(input, {
                attributes: true,
            });
        }
        return () => {
            observer.disconnect();
        };
    }, [input]);
    return (React.createElement("div", { ref: containerRef },
        React.createElement(Autocomplete, { popoverProps: { a11yLabel: 'autocomplete' }, options: {
                itemsToDisplay: undefined,
                setInputItems: () => undefined,
                items,
                isAutocomplete: false,
                isHighlight: false,
                onInputValueChange: (changes) => {
                    setInputValue(changes.inputValue || '');
                    if (onChange)
                        onChange(changes.inputValue || inputValue);
                },
            } },
            React.createElement(AutocompleteInput, { value: !clearInput ? inputValue : '' }),
            React.createElement(AutocompleteList, null,
                React.createElement(AutocompleteListItems, null, items.map((item, index) => (React.createElement(AutocompleteListItem, { sx: {
                        // TODO: fix this selector
                        '&[type="button"]': {
                            _hover: {
                                backgroundColor: 'colorBorderSubdued',
                            },
                        },
                    }, key: item, item: item, index: index }))))))));
};
export default AutocompleteComponent;
